/* eslint-disable no-unused-vars */
import { action, observable } from 'mobx';
import axios from 'axios';
import {
    PROMO_COUPON_TRIAL_EXPIRED,
    PROMO_COUPON_ANNUAL_INCENTIVE,
    PROMO_COUPON_MONTHLY_15
} from '~/common/utils/consts.js';
import { isBoolean, isObject } from '~/common/utils/typeCheckers';

const promoLabels = {
    promoHeader: 'Different ways to save!',
    promoMessage: 'For a limited time only get up to $125 off select virtual phone plans when you buy now. Save even more when you buy annual!',
    expiredTrialPromoHeader: 'Keep the phone ringing!',
    expiredTrialPromoSubHeader: 'Select a plan to upgrade today and save up to $75.',
    expiredTrialPromoMessage: 'The number you used for your trial may no longer be available, but you can still get a perfect number for your business!'
};

const promos = {
    annualPromo: PROMO_COUPON_ANNUAL_INCENTIVE,
    // Removing Monthly Coupon for the newly added True Solo Plan Work
    monthlyPromo: '',
    expiredTrialPromo: PROMO_COUPON_TRIAL_EXPIRED
};

class CMSClass {
    @observable promoLabels = promoLabels;
    @observable promos = promos;
    @observable hasLoaded = false;

    bootstrapStore() {
        this.getContent();
    }

    @action setPromoLabels(obj) {
        this.promoLabels = isObject(obj, this.promoLabels);
    }

    @action setPromos(obj) {
        this.promos = isObject(obj, this.promos);
    }

    @action setHasLoaded(bool) {
        this.hasLoaded = isBoolean(bool, this.hasLoaded);
    }

    @action getContent() {
        const url = window.location.origin.split('signup.').join('');
        const mapUrl = {
            'https://review.grasshopper.com': 'https://rc.grasshopper.com',
            'https://gamma.grasshopper.com': 'https://staging.grasshopper.com',
            'https://us-dev.ghus-aws.com': 'https://rc.grasshopper.com',
            'https://us-stg.ghus-aws.com': 'https://staging.grasshopper.com'
        };
        axios.get(`${mapUrl[url] || url}/api/sitecore/signup/promobanner`)
            .then((res) => {
                const { header, message, expiredTrialHeader, expiredTrialMessage, expiredTrialSubheader, annualPromoCode, monthlyPromoCode, expiredTrialPromoCode } = res.data;
                this.setPromoLabels({
                    promoHeader: header,
                    promoMessage: message,
                    expiredTrialPromoHeader: expiredTrialHeader,
                    expiredTrialPromoSubHeader: expiredTrialSubheader,
                    expiredTrialPromoMessage: expiredTrialMessage
                });
                this.setPromos({
                    annualPromo: annualPromoCode,
                    monthlyPromo: monthlyPromoCode,
                    expiredTrialPromo: expiredTrialPromoCode
                });
                this.setHasLoaded(true);
            }).catch((err) => {
                this.setHasLoaded(true);
                throw err;
            });
    }
}

const cmsStore = new CMSClass();
export { cmsStore, CMSClass };
